import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PublicRoute = () => {
  const token = localStorage.getItem('Token'); 

  if (token) {
    return <Navigate to="/organization" replace />;
  }

  return <Outlet />; 
};

export default PublicRoute;
